<template>
  <div id="app">
    <div>
      <router-view />
    </div>
    <!-- <vfooter></vfooter> -->
  
  </div>
</template>

<script>
import vfooter from "./components/base/vfooter";
// 导入登录模块
import loginBox from "./components/login/login";

export default {
  name: "App",
  created() {
   
    if (
      sessionStorage.getItem("ntoice") == null &&
      localStorage.isFlag == undefined
    ) {
      localStorage.isFlag = "true";
    }
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });

    

  },
  components: {
    vfooter,
    loginBox,
  },
  updated() {
    // this.axios({
    //   method: "post",
    //   url: this.url + "/api/new_user/isLogin",
    //   data: {
    //     token: window.localStorage.getItem("token"),
    //   },
    // }).then((res) => {
    //   if (res.data.data == null) return;
    //   this.store.commit("setMsg", res.data.data.msg_status);
    //   if (res.data.code != 0 || res.data.data.status == 2) {
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("username");
    //     localStorage.removeItem("uid");
    //     localStorage.removeItem("usinfo");
    //   }
    // });
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  background-color: #f2f2f2;
}
body {
  margin: 0;
  padding: 0;
}
div,
dl,
dt,
dd,
form,
h1,
h2,
h3,
h4,
h5,
h6,
img,
ol,
ul,
li,
table,
th,
td,
p,
span,
a {
  border: 0;
  font-weight: normal;
  margin: 0;
  padding: 0;
}

img,
input {
  border: none;
  vertical-align: middle;
  outline: none;
}

body {
  font-family: "Microsoft YaHei", tahoma, arial, "Hiragino Sans GB",
    "\5b8b\4f53", sans-serif;
  font-size: 0.857142rem;
  background: #fff;
  color: #212121;
  /*line-height: 30px;*/
  background: rgb(244, 241, 244);
  padding: 0;
  margin: 0;
}
body::-webkit-scrollbar {
     width: 0 !important;
   }
   body::-webkit-scrollbar {
     width: 0 !important;height: 0;
   }
/*html {
        overflow-y: scroll;
}*/

ul,
ol,
li {
  list-style-type: none;
}

th,
td,
input {
  font-size: 0.857142rem;
}

h3 {
  font-size: 1rem;
}

button {
  border: none;
  cursor: pointer;
  font-size: 0.857142rem;
  background-color: transparent;
}

select {
  border-width: 1px;
  _zoom: 1;
  border-style: solid;
  padding-top: 0.142857rem;
  font-size: 0.857142rem;
}
hr {
  border: 0;
  height: 0.071428rem;
  width: auto;
  background-color: #e8e8e8;
  margin: 0.714285rem;
}
.clear {
  clear: both;
  font-size: 0.071428rem;
  height: 0;
  visibility: hidden;
  line-height: 0;
}

.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
}
.pointer {
  cursor: pointer;
}
.el-dialog {
  border-radius: 0.571428rem;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 0 !important;
}
.phone-con .el-form-item__label::before {
  display: none;
}
.ps-jj textarea {
  resize: none !important;
}
.pc-right-in .s-box .el-button--primary.is-disabled,
.pc-right-in .s-box .el-button--primary.is-disabled:hover {
  background: rgba(22, 109, 159, 0.6);
  color: #fff;
}
.percenter-prop .border-b {
  border-bottom: none;
}
.percenter-prop .border-b .name {
  font-size: 18px;
}
.percenter-prop .border-b .name img {
  width: 10px;
  height: 20px;
}
.el-dialog--center .el-dialog__body {
  padding: 1.428571rem 1.428571rem 0.714286rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue